import { benefitInitalState } from '@/modules/benefit/entities/constants/benefit';
import { Plan } from '@/modules/plan/entities/intefaces/plan';
import { providerInitalState } from '@/services/negotiations/endpoints/providers';

export const productInitialState: Plan = {
  name: '',
  baseId: 0,
  benefitId: '',
  providerId: '',
  benefit: benefitInitalState,
  provider: providerInitalState,
  negotiations: [],
};
